// 神策
const hostName = window.location.hostname

let url = ''
if (/localhost|^192\.168|^172/.test(hostName)) {
  url = 'http://192.168.106.156:8107/import/?project=default'
} else {
  url = 'https://uba.huolalamove.net/sa?project=default'
}

export const saUrl = url
